import styled from '@emotion/styled';
import { Box } from '@mui/material';

import Image from '@/contents/General/Image';
import {
  getUserBackGroundImageUrl,
  getUserIconImageUrl,
} from '@/modules/User/getUserImageUrl';
import type { PublicUser } from '@/types/domain';
import { getBlankName } from '@/utils/GetBlankString';

import Typography from '../General/Typography';

const MainVisual = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vw;
  max-height: 428px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 55%, #333333bd 100%);
`;

const AccountImageBox = styled(Box)`
  display: flex;
  justify-content: center;
  position: relative;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 0;
  overflow: hidden;
`;
const UserImage = ({ user }: { user: PublicUser }) => {
  return (
    <MainVisual>
      <Image
        src={getUserBackGroundImageUrl(user)}
        fill
        alt="アカウント背景画像"
      />
      <AccountImageBox>
        <Image
          src={getUserIconImageUrl(user)}
          fill
          alt="アカウントアイコン画像"
        />
      </AccountImageBox>
      <Box position="absolute" height={180}>
        <Typography
          fontSize={21}
          fontWeight={700}
          color="white"
          textAlign="center"
          paddingTop="196px"
          variant="h1"
        >
          {user.display_name ?? getBlankName()}
        </Typography>
      </Box>
    </MainVisual>
  );
};
export default UserImage;
